/** Positional-theta operator endpoints (docs/positional_theta.md 3.0.2). */

import { getJson } from "@/lib/http";

export interface TakeEntryResponse {
  placed: boolean;
  dry_run: boolean;
  detail: string;
}

export interface ThetaStatus {
  dry_run: boolean;
  last_bar_ts: string | null;
  last_action: string | null;
  sizing_base: number;
  allocated_funds: number;
  deploy_fraction: number;
  has_open_basket: boolean;
  /** The hourly trend filter as the engine last read it. UP sells PUT
   * spreads, DOWN sells CALL spreads, null is a mixed bar that trades
   * nothing. */
  trend: "UP" | "DOWN" | null;
  /** The SuperTrend line and 20 EMA behind that verdict. The DISTANCE is
   * the point: a trend reading UP with the line 200 points below price is
   * a very different thing from one sitting just under it. */
  st_value: number | null;
  ema: number | null;
  stop_multiple: number | null;
}

export const thetaApi = {
  status(strategyId: string): Promise<ThetaStatus> {
    return getJson<ThetaStatus>(`/api/strategies/${strategyId}/theta/status`);
  },
  takeEntry(strategyId: string): Promise<TakeEntryResponse> {
    return getJson<TakeEntryResponse>(`/api/strategies/${strategyId}/theta/take-entry`, {
      method: "POST",
    });
  },
};
